<template>
  <div
    style="
      overflow: hidden;
      display: flex;
      flex-direction: column;
      height: 100%;
    "
  >
    <ul
      style="
        border-bottom: 1px solid #e2e2e2;
        padding: 15px;
        display: flex;
        align-items: center;
      "
    >
      <li style="flex: 1">权限配置</li>
      <div style="display:flex;gap:8px;margin-right:10px">
        <el-button size="small" @click="onSelectAll">全选</el-button>
        <el-button size="small" @click="onDeselectAll">全不选</el-button>
      </div>
      <el-button type="primary" @click="onSubmit()">提交</el-button>
    </ul>
    <ul style="font-size: 14px; padding-left: 20px; overflow-y: auto; flex: 1">
      <template v-for="item in state.data" :key="item">
        <div style="margin-bottom: 20px">
          <ul>
            <el-checkbox
              :checked="
                state.selectArr.includes(
                  'M_' + item.TableName + (item.Menu ? '_' + item.Menu : '')
                )
              "
              style="font-weight: 600"
              :label="
                'M_' + item.TableName + (item.Menu ? '_' + item.Menu : '')
              "
              @change="
                onCheckChange(
                  'M_' + item.TableName + (item.Menu ? '_' + item.Menu : ''),
                  $event
                )
              "
              :key="state.key"
              >{{ item.Title }}</el-checkbox
            >
          </ul>
          <ul
            style="padding-left: 10px"
            v-if="item.BtnArr?.length > 0"
            :key="state.key"
          >
            <el-checkbox
              v-for="btn in item.BtnArr"
              :key="btn"
              :checked="
                state.selectArr.includes('B_' + item.TableName + '_' + btn)
              "
              :label="'B_' + item.TableName + '_' + btn"
              @change="onCheckChange('B_' + item.TableName + '_' + btn, $event)"
              >{{ btn }}</el-checkbox
            >
          </ul>
          <ul
            style="padding-left: 10px"
            v-if="item.DataArr?.length > 0"
            :key="state.key"
          >
            <template v-for="btn in item.DataArr" :key="btn">
              <el-checkbox
                :checked="
                  state.selectArr.includes('D_' + item.TableName + '_' + btn)
                "
                :label="'D_' + item.TableName + '_' + btn"
                @change="onDataChange('D_' + item.TableName + '_', btn, $event)"
                >{{ btn }}
              </el-checkbox>
            </template>
          </ul>
        </div>
      </template>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { juese_getqx, juese_setqx } from "@/http/api";
import { menuTree, extraAuthItems } from "@/config/menuConfig";
import { ElMessage } from "element-plus";

// 从菜单配置生成权限列表
function buildAuthList() {
  const list = [];
  function walk(items) {
    for (const item of items) {
      if (item.permission) {
        const entry = { Title: item.title, TableName: item.permission };
        if (item.btnArr) entry.BtnArr = item.btnArr;
        if (item.dataArr) entry.DataArr = item.dataArr;
        list.push(entry);
      }
      if (item.children) walk(item.children);
    }
  }
  walk(menuTree);
  for (const item of extraAuthItems) {
    const entry = { Title: item.title, TableName: item.permission };
    if (item.btnArr) entry.BtnArr = item.btnArr;
    if (item.dataArr) entry.DataArr = item.dataArr;
    list.push(entry);
  }
  return list;
}
export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const state = reactive({
      selectArr: [],
      data: buildAuthList(),
    });
    onMounted(() => {
      juese_getqx(props.id).then((res) => {
        if (res.status == 200) {
          console.log(res.data);
          state.selectArr = res.data;
          state.key = Math.random();
        }
      });
    });

    const onCheckChange = (value, checked) => {
      console.log(value);
      if (checked) {
        state.selectArr.push(value);
      } else {
        const index = state.selectArr.findIndex((w) => w == value);
        if (index > -1) {
          state.selectArr.splice(index, 1);
        }
      }
      state.key = Math.random();
    };

    const onDataChange = (prefix, value, checked) => {
      if (checked) {
        const index = state.selectArr.findIndex((w) => w.includes(prefix));
        if (index > -1) {
          state.selectArr.splice(index, 1);
        }
        state.selectArr.push(prefix + value);
      } else {
        const index = state.selectArr.findIndex((w) => w == prefix + value);
        if (index > -1) {
          state.selectArr.splice(index, 1);
        }
      }
      state.key = Math.random();
    };

    const onSubmit = () => {
      console.log(state.selectArr);
      // let i = 1;
      // if (i == 1) return false;
      juese_setqx(props.id, state.selectArr).then((res) => {
        ElMessage({
          message: res.data,
          showClose: true,
          dangerouslyUseHTMLString: true,
          type: res.status ? "success" : "error",
        });
        if (res.status == 200) {
          setTimeout(() => {
            emit("close");
          }, 500);
        }
      });
    };

    const onSelectAll = () => {
      const arr = [];
      state.data.forEach((item) => {
        arr.push('M_' + item.TableName + (item.Menu ? '_' + item.Menu : ''));
        if (item.BtnArr) {
          item.BtnArr.forEach((btn) => arr.push('B_' + item.TableName + '_' + btn));
        }
        if (item.DataArr) {
          // 数据权限只选"全部"
          arr.push('D_' + item.TableName + '_' + item.DataArr[0]);
        }
      });
      state.selectArr = arr;
      state.key = Math.random();
    };

    const onDeselectAll = () => {
      state.selectArr = [];
      state.key = Math.random();
    };

    return { state, onCheckChange, onDataChange, onSubmit, onSelectAll, onDeselectAll };
  },
};
</script>
<style scoped></style>
